import { render } from "./LunarDate.vue?vue&type=template&id=2bc733e7&scoped=true"
import script from "./LunarDate.vue?vue&type=script&lang=js"
export * from "./LunarDate.vue?vue&type=script&lang=js"

import "./LunarDate.vue?vue&type=style&index=0&id=2bc733e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc733e7"]])

export default __exports__